import axios from "axios";

const API_BASE_URL = "/api/contacts";

/**
 * Contact API Service
 * Handles all HTTP requests related to contact operations
 */
class ContactService {
  /**
   * Create a new contact
   */
  async createContact(contactData) {
    try {
      const response = await axios.post(API_BASE_URL, contactData, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get all contacts with pagination and filters
   */
  async getAllContacts(params = {}) {
    try {
      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append("page", params.page);
      if (params.limit) queryParams.append("limit", params.limit);
      if (params.search) queryParams.append("search", params.search);
      if (params.isActive !== undefined)
        queryParams.append("isActive", params.isActive);
      if (params.sort) queryParams.append("sort", params.sort);

      const response = await axios.get(
        `${API_BASE_URL}?${queryParams.toString()}`
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get single contact by ID
   */
  async getContactById(contactId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${contactId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Update contact
   */
  async updateContact(contactId, contactData) {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/${contactId}`,
        contactData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Delete contact
   */
  async deleteContact(contactId) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/${contactId}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Get all active contacts (for dropdowns)
   */
  async getActiveContacts() {
    try {
      const response = await axios.get(`${API_BASE_URL}/active/list`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Handle API errors
   */
  handleError(error) {
    if (error.response) {
      return {
        message: error.response.data?.message || "An error occurred",
        status: error.response.status,
        data: error.response.data,
      };
    } else if (error.request) {
      return {
        message: "Network error. Please check your connection.",
        status: 0,
      };
    } else {
      return {
        message: error.message || "An unexpected error occurred",
        status: 0,
      };
    }
  }
}

const contactService = new ContactService();
export default contactService;

